import { IApplicationState } from '../../types/redux';

export function getContacts(state: IApplicationState) {
  return state.developer?.contacts;
}
